import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import MenuHelper from "../../../../helpers/MenuHelper";
import { NavLink } from "react-router-dom";

const HoverListingNav = (props) => {

    return (
        <>
            {props?.v.status && !Object.values(props.menuList).some((submenu) => submenu.parent_menu_code === props?.v.code) &&
                !(props?.v.location == "sub_menu" && !props?.v.parent_menu_code) ? (
                <div className={props?.componentSetting?.["horizonatal-nav-bar"]?.["default-value"]}>
                    <li className="hover-listing-menu">
                        {props?.v.code ? (
                            <NavLink
                                to={props?.customLink}
                                onMouseOver={() => props?.mouseOver(props?.v.code)}
                            >
                                <MenuHelper t={props.t} ftpPath={props?.ftpPath} data={props?.v} className={""} />
                            </NavLink>
                        ) : (
                            <NavLink onMouseOver={() => props?.mouseOver(props?.v.code)}>
                                <MenuHelper t={props.t} ftpPath={props?.ftpPath} data={props?.v} className={""} />
                            </NavLink>
                        )}
                    </li>
                </div>
            ) : null}
        </>
    );
};

HoverListingNav.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(HoverListingNav);
